module.exports = __webpack_public_path__ + "img/XT2.033e58a1.png";